import { FilterGroup } from 'components/Filters/components/FilterModal'
import { FilterStore } from 'components/Filters/FilterStore'
import {
  RangeFilter,
  RangeFilterWithMinMax,
} from 'components/Filters/fields/RangeFilter'
import {
  createFilterColumnHelper,
  DataTypeColumn,
} from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { ZipcodeFilter } from 'components/Filters/fields/ZipcodeFilter'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { ALL_COUNTRIES } from 'utils/countries'
import { CityAndStateFilter } from 'components/Filters/components/CityAndStateFilter'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { GooglePlaceDoorBaseWithProxyFields } from '../GooglePlaceDoorsBaseColumnsInfo'
import { TableTypeSlug } from 'models/companies'

export function CommonFiltersetGooglePlaceDoorGroup({
  filterStore,
  columns,
  companyType,
}: {
  filterStore: FilterStore
  columns: Record<keyof GooglePlaceDoorBaseWithProxyFields, DataTypeColumn>
  companyType: TableTypeSlug
}) {
  const featureFlags = useFeatureFlagService()
  const commonGooglePlaceFilterHelper = createFilterColumnHelper({
    columns,
  })

  return (
    <>
      <FilterGroup title="Target Attributes">
        <RangeFilterWithMinMax
          {...commonGooglePlaceFilterHelper.retrieveProps('reviews_avg')}
          store={filterStore}
          min={0}
          max={5}
          decimalScale={2}
        />
        <RangeFilter
          {...commonGooglePlaceFilterHelper.retrieveProps('reviews_cnt')}
          store={filterStore}
        />
        <RangeFilter
          {...commonGooglePlaceFilterHelper.retrieveProps('chain_doors_cnt')}
          store={filterStore}
        />
      </FilterGroup>

      <FilterGroup title="Location">
        {featureFlags.enableRestaurantsCountryFilter && (
          <SelectFilter
            {...commonGooglePlaceFilterHelper.retrieveProps('country')}
            options={ALL_COUNTRIES}
            filterStore={filterStore}
          />
        )}
        <CityAndStateFilter
          filterStore={filterStore}
          stateSelectProps={commonGooglePlaceFilterHelper.retrieveProps(
            'state'
          )}
          citySelectProps={commonGooglePlaceFilterHelper.retrieveProps('city')}
          companyType={companyType}
        />
        <ZipcodeFilter filterStore={filterStore} />
      </FilterGroup>
    </>
  )
}
